var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "call-logs-quick-filter" },
    [
      _c(
        "Tabs",
        {
          on: { "before-change": _vm.onBeforeTabChange, change: _vm.loadData },
          model: {
            value: _vm.selectedGroupBy,
            callback: function($$v) {
              _vm.selectedGroupBy = $$v
            },
            expression: "selectedGroupBy"
          }
        },
        [
          _vm._l(_vm.tabGroupings, function(column, idx) {
            return _c("Tab", { key: idx, attrs: { title: column.displayName } })
          }),
          _vm._v(" "),
          !_vm.hideTags
            ? _c(
                "Tab",
                [
                  _c("template", { slot: "title" }, [
                    _c(
                      "span",
                      { ref: "tagsTab", on: { click: _vm.onTabClick } },
                      [
                        _vm._v("\n          Tags\n          "),
                        _c("i", { staticClass: "m-l-5 fa fa-angle-down" })
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      !_vm.hideTags
        ? _c(
            "popover",
            {
              attrs: {
                "custom-class": "breakdown-legend__popover",
                placement: "bottom",
                trigger: "manual",
                target: _vm.$refs.tagsTab
              },
              on: {
                show: function($event) {
                  _vm.tagsPopoverVisible = true
                },
                hide: function($event) {
                  _vm.tagsPopoverVisible = false
                }
              },
              model: {
                value: _vm.showTagsPopover,
                callback: function($$v) {
                  _vm.showTagsPopover = $$v
                },
                expression: "showTagsPopover"
              }
            },
            [
              _c(
                "template",
                { slot: "popover" },
                [
                  _c("InsightsGroupByDropdown", {
                    staticClass: "insights-group-by-dropdown",
                    attrs: {
                      "available-group-bys": _vm.tagGroupBys,
                      "trigger-element":
                        _vm.$refs.tagsTab &&
                        _vm.$refs.tagsTab.parentNode.parentNode,
                      "focus-dropdown": _vm.tagsPopoverVisible
                    },
                    on: {
                      input: _vm.onGroupByChange,
                      blur: function($event) {
                        _vm.showTagsPopover = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showPartialDataSetMessage
            ? _c(
                "div",
                {
                  staticClass:
                    "reporting-grid-notification--partial bg-info m-t-2",
                  on: { click: _vm.hidePartialDatasetNotification }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-times pull-right m-t-3 m-l-5"
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-info m-t-3 m-r-5" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PARTIAL_DATA_SET_MESSAGE",
                        expression: "'PARTIAL_DATA_SET_MESSAGE'"
                      }
                    ]
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("AgGridVue", {
            staticClass:
              "ag-grid--custom ag-grid--call-logs ag-grid--call-logs-quick-insights ag-theme-balham-dark",
            attrs: {
              "row-data": _vm.rowData.allRecords,
              "default-col-def": _vm.defaultColDef,
              "column-defs": _vm.columnDefs,
              "column-types": _vm.colTypes,
              "group-header-height": 0,
              "suppress-context-menu": true,
              "suppress-movable-columns": true,
              "overlay-no-rows-template": _vm.overlayNoRowsTemplate,
              "suppress-animation-frame": true,
              "suppress-column-move-animation": true,
              "suppress-column-state-events": true,
              "suppress-property-names-check": true,
              "tooltip-show-delay": 0,
              "dom-layout": "autoHeight"
            },
            on: {
              "grid-ready": _vm.onGridReady,
              cellClicked: _vm.onCellClicked,
              sortChanged: _vm.onSortChange,
              columnResized: _vm.onColumnResized
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }